import React, { useEffect, useState } from "react";
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBContainer,
} from "mdb-react-ui-kit";
import axios from "axios";
// config
import configData from "../../../config/config.json";
// components
import MetaTagsBusinessOwners from "../../../components/meta-tags-seo/MetaTagsBusinessOwners";
import Sidbarbusiness from "../../../components/business-dashboard/sidbar/Sidbarbusiness";
import HeaderMobile from "../../../components/business-dashboard/sidbar/HeaderMobile";
import AlertSuccess from "../../../components/AlertSuccess/AlertSuccess";

import Delete from "../../../images/register-business/delete.png";
import boxMassage from "../../../images/end user/postbox.png";

const BusinessMessage = (props) => {
  const [render, setRender] = useState(false);

  const [data, setdata] = useState([
    // {
    //   id: 1,
    //   title: "رستوران گیشنیز",
    //   desc1: "شما به این کسب‌وکار امتیاز 5 داده‌اید",
    //   time: " در تاریخ 23 جولای 2022",
    //   author: "نوشته شده توسط زهرا امیری",
    //   text: "It's a nice, sturdy little stand for a headset. The metal is actually stronger than I expected it to be, and there's rubbe where it sits on the desk and where the headband of the headset rests on the stand, which is",
    // },
    // {
    //   id: 2,
    //   title: "رستوران گیشنیز",
    //   desc1: "شما به این کسب‌وکار امتیاز 5 داده‌اید",
    //   time: " در تاریخ 23 جولای 2022",
    //   author: "نوشته شده توسط زهرا امیری",
    //   text: "It's a nice, sturdy little stand for a headset. The metal isactually stronger than I expected it to be, and there's rubbe where it sits on the desk and where the headband of the headset rests on the stand, which is",
    // },
  ]);
  const toggleShow = () => setCentredModal(!centredModal);
  const [centredModal, setCentredModal] = useState(false);
  const [idDelete, setIdDelete] = useState(null);
  const [showAlert, setshowAlert] = useState(false);

  const setIDforDelete = (idDelete) => {
    setIdDelete(idDelete);
  };
  const deleteHandeler = () => {
    setdata(data.filter((item) => item.id !== idDelete));
  };
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      setshowAlert(false);
    }, 5000);
  };

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "business-message",
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else if (render) {
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  }, [render]);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  let windowWidth = "00";
  if (typeof window !== "undefined") {
    // Code that relies on the window object
    windowWidth = window.innerWidth;
  } else {
    windowWidth = "00";
  }

  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      {windowWidth < 768 ? <HeaderMobile setRender={setRender} /> : ""}
      <div className="margin-0 d-flex bg_business_grey">
        <div className="  d-none d-md-block">
          {windowWidth > 767 ? <Sidbarbusiness setRender={setRender} /> : ""}
        </div>
        <MDBContainer className="bg_business_grey">
          <MDBRow>
            <MDBCol size="12">
              <div>
                <p className="text_img_bus">پیام‌ها</p>
              </div>
              {data.length > 0 && (
                <div className="container_img_bus_content_ping">
                  <div>
                    <p className="header_text_bus_message">پیام خوانده نشده</p>
                  </div>

                  {data.length > 0 &&
                    data.map((item) => (
                      <div key={item.id}>
                        <div className="box_in_ping_message">
                          <div className="first_part_box">
                            <span className="span_right_ping">مدیر سیستم</span>
                            <span className="proofile_tooltip ">
                              <img
                                src={Delete}
                                alt="Delete"
                                className="img_delet_bus_message"
                                onClick={() => {
                                  toggleShow();
                                  setIDforDelete(item.id);
                                }}
                              />
                              <span className="tooltiptext_option f12 message_hover_bus">
                                حذف
                              </span>
                            </span>
                          </div>
                          <div className="second_part_box">
                            <p className="p_right_ping">
                              درخواست شما برای ارتقا حساب کاربری دریافت شد.
                            </p>
                            <div className="d-flex dash-bus-message-timedate">
                              <span className="ms-4">8:23</span>
                              <span>20/7/1401</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol size="12">
              <div className="box_tow_message  d-flex justify-content-center align-items-center">
                <MDBCol size="12" className={data.length > 0 && "manfimt90"}>
                  {data.length === 0 ? (
                    <div className="t_a_l_c">
                      <img
                        className="boxMassage_business "
                        src={boxMassage}
                        alt="boxMassage"
                      />
                      <p className="text_no_image mb-2 mx-auto">
                        پیام جدیدی وجود ندارد
                      </p>
                    </div>
                  ) : (
                    <>
                      <div>
                        <p className="header_text_bus_message mt_manfi126">
                          پیام خوانده شده
                        </p>
                      </div>
                      {data.map((item) => (
                        <div key={item.id}>
                          <div className="box_in_ping_message">
                            <div className="first_part_box">
                              <span className="span_right_ping">
                                مدیر سیستم
                              </span>
                              <span className="proofile_tooltip ">
                                <img
                                  src={Delete}
                                  alt="Delete"
                                  className="img_delet_bus_message"
                                  onClick={() => {
                                    toggleShow();
                                    setIDforDelete(item.id);
                                  }}
                                />
                                <span className="tooltiptext_option f12 message_hover_bus">
                                  حذف
                                </span>
                              </span>
                            </div>
                            <div className="second_part_box">
                              <p className="p_right_ping">
                                درخواست شما برای ارتقا حساب کاربری دریافت شد.
                              </p>
                              <div className="d-flex dash-bus-message-timedate ">
                                <span className="ms-4">8:23</span>
                                <span>20/7/1401</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </MDBCol>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>

      <MDBModal
        tabIndex="-1"
        show={centredModal}
        setShow={setCentredModal}
        id={idDelete}
      >
        <MDBModalDialog centered className="justify-content-center">
          <MDBModalContent className="costum_modal">
            <div className="reletive_profile">
              <MDBBtn
                className="btn-close close_modal"
                color="none"
                onClick={toggleShow}
              ></MDBBtn>
            </div>
            <div>
              <p className="text_modal px-3">
                آیا می‌خواهید این دیدگاه از لیست دیدگاه‌‌هایتان پاک شود؟
              </p>
            </div>
            <div className="a_s_c">
              <button
                onClick={() => {
                  toggleShow();
                  deleteHandeler();
                  alertHandeler();
                }}
                className="button_modal"
              >
                حذف شود
              </button>
            </div>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      <AlertSuccess
        showAlert={showAlert}
        text={"پیام شما با موفقیت حذف شد ."}
      />
    </>
  );
};

export default BusinessMessage;
